import firebase from "firebase";
import dayjs from "dayjs";
import {isCache} from "../plugins/firebase";

export const getCurrentUser = async (project_id, uid, planId) => {
  let currentUser = null;

  const path = 'USER_' + JSON.stringify({
    project_id, uid, planId
  })

  const cache = localStorage.getItem(path);
  if (!cache || Number(JSON.parse(cache).expire) < dayjs().unix()) {

    const data = await myFirestore
      .collection('projects')
      .doc(project_id)
      .collection('users')
      .where('uid', '==', uid)
      .get()


    data.forEach((subDoc) => {
      currentUser = subDoc.data();
    });

    if(isCache) {

      localStorage.setItem(path, JSON.stringify({currentUser, expire: dayjs().add(10, 'minute').unix()}))
    }

  } else {
    currentUser = JSON.parse(cache).currentUser
  }

  if (planId) {
    // console.log(currentUser.plan_permission, currentUser, 'currentUser')
    if (currentUser.plan_permission && currentUser.plan_permission[planId]) {
      return currentUser.plan_permission[planId] || {}
    }
    return currentUser[planId] || {}
  }


  return currentUser;
}

export const getPermission = async (project_id, uid, planId, returnAllPermission) => {

  const path = 'PERM_' + JSON.stringify({
    project_id, uid, planId
  })

  const cache = localStorage.getItem(path);

  let user = {};

  if (!cache || Number(JSON.parse(cache).expire) < dayjs().unix()) {
    let currentUser = await getCurrentUser(project_id, uid);

    if (currentUser.role === 'admin') {
      if (returnAllPermission) {
        return null
      }
      return {
        available_jobs: null,
        available_objects: null
      }
    }

    const user_d = await myFirestore
      .collection('projects')
      .doc(project_id)
      .collection('users')
      .where('isCompany', '==', true)
      .where('company', '==', currentUser.company)

      .get();

    user_d.forEach((subDoc) => {
      user = subDoc.data();
    });
    if(isCache) {
      localStorage.setItem(path, JSON.stringify({user, expire: dayjs().add(10, 'minute').unix()}))
    }
  } else {
    user = JSON.parse(cache).user
  }


  if (returnAllPermission) {
    return user
  }

  if (!user.usePermission && !planId) {
    return {
      usePermission: false,
      available_jobs: null,
      available_objects: null,
    }
  }

  console.log(planId, user, 'planId')

  if (planId) {

    if (!user.plan_permission || !user.plan_permission[planId] || !user.plan_permission[planId].usePermission) {
      return {
        usePermission: false,
        available_jobs: null,
        available_objects: null,
      }
    }

    return {
      usePermission: true,
      available_jobs: user.plan_permission && user.plan_permission[planId] && user.plan_permission[planId].available_jobs || [],
      available_objects: user.plan_permission && user.plan_permission[planId] && user.plan_permission[planId].available_objects || []
    }
  }

  return {
    usePermission: true,
    available_jobs: user.available_jobs || [],
    available_objects: user.available_objects || []
  }
}


export const getPermissionByUser = async (project_id, uid, plan) => {

  let currentUser = await getCurrentUser(project_id, uid, plan);

  if (!currentUser.usePermission) {
    return {
      available_objects: null,
    }
  }

  return {
    available_objects: currentUser.available_objects || []
  }
}

export const getPermissionDocs = async (project_id, uid) => {
  let currentUser = await getCurrentUser(project_id, uid);

  if (currentUser.role === 'admin') {
    return {
      available_files: null,
      available_docs: null
    }
  }

  let user = {};
  const user_d = await myFirestore
    .collection('projects')
    .doc(project_id)
    .collection('users')
    .where('isCompany', '==', true)
    .where('company', '==', currentUser.company)
    .get();

  user_d.forEach((subDoc) => {
    user = subDoc.data();
  });

  if (!user.usePermissionDocs) {
    return {
      available_files: null,
      available_docs: null,
    }
  }

  return {
    available_files: user.available_files || [],
    available_docs: user.available_docs || []
  }
}

export const getRole = async (project_id) => {
  const sub = await myFirestore
    .collection('projects')
    .doc(project_id).get();

  const data = sub.data();
  let role = 'admin';
  if (data) {
    const rules = data.rules;
    if (rules) {
      role = rules[authFirestore.currentUser.uid];
      if (data.isDemo) {
        role = 'admin';
      }
    }
  }

  return role;
}

export const getMyCompanyUsers = async (project_id) => {
  let currentUser = await getCurrentUser(project_id, authFirestore.currentUser.uid);


  const user_d = await myFirestore
    .collection('projects')
    .doc(project_id)
    .collection('users')
    // .where('isCompany', '==', true)
    .where('company', '==', currentUser.company)
    .get();
  const result = [];

  user_d.forEach((subDoc) => {
    result.push(subDoc.data().uid);
    result.push(subDoc.id);
  });

  result.push(currentUser.company)

  return result;
}


export const isApprove = async (project_id) => {
  let currentUser = await getCurrentUser(project_id, authFirestore.currentUser.uid);


  if (currentUser.role === 'admin') {
    return true
  }

  if (currentUser.role === 'worker') {
    return false
  }

  const user_d = await myFirestore
    .collection('projects')
    .doc(project_id)
    .collection('users')
    .where('company', '==', currentUser.company)
    .get();
  let user = null

  user_d.forEach((subDoc) => {
    if (subDoc.data().isCompany) {
      user = subDoc.data();
    }
  });

  return user && user.editorApprove;
}



// WEBPACK FOOTER //
// ./src/firestore/permission.js